export const DeleteTemplateModal: string = 'DeleteTemplateModal';
